const { render, useState } = wp.element;
import React, { Component } from 'react';
import { withTranslation } from "react-i18next";

//Import Designs
import { Typography, Link, Backdrop, CircularProgress } from '@mui/material';

class DisplayAuthorInfo extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        const { t, i18n } = this.props;
        const allprops = this.props;
        let authorname = null;
        let authoremail = null;

        if (typeof allprops.short.allcatoption !== "undefined") {
            authorname = allprops.short.allcatoption.authordisplay;
            authoremail = allprops.short.allcatoption.authornamedisplay;
        }
        if (this.props.singlepost) {
            return (
                <div className="wpvc_card_conthead_author">
                    {authorname == 'on' && this.props.singlepost.author_name != '' &&
                        <Link href={undefined} onClick={() => this.props.changeauthor(this.props.singlepost.author)}>
                            <Typography
                                className="wpvc_card_sub_header">
                                {t("fr_author_name")}{this.props.singlepost.author_name}
                            </Typography>
                        </Link>
                    }
                    {authoremail == 'on' && this.props.singlepost.author_email != '' &&
                        <Link href={undefined} onClick={() => this.props.changeauthor(this.props.singlepost.author)}>
                            <Typography
                                className="wpvc_card_sub_header">
                                {t("fr_author_email")}{this.props.singlepost.author_email}
                            </Typography>
                        </Link>
                    }
                </div>
            )
        } else {
            return <Backdrop className="wpvc_back_loader" open={true}>
                <CircularProgress color="inherit" />
            </Backdrop>
        }

    }
}

export default (withTranslation("translations")(DisplayAuthorInfo));
